/*jshint globalstrict: false*/
import { gsap } from "gsap";

export default {
    methods: {
        createTimeLineForOnboardingQuiz(questionCards, cardWrapper, selectedCardIndex, duration = 0.2) {
            const selectedCard = questionCards[selectedCardIndex];
            const unselectedCards = questionCards.filter((card, i) => i !== selectedCardIndex);

            let animationTimeLine = gsap.timeline();

            animationTimeLine.to(unselectedCards, {
                x: function (index, target) {
                    // Move the element to the left / right, if it's located on the left / right of the screen.
                    const targetOffsetLeft = target.offsetLeft;
                    const parentCenter = target.offsetParent.offsetWidth / 2;
                    return targetOffsetLeft < parentCenter ? -200 : 200
                },
                opacity: 0,
                duration,
            }, 0);

            animationTimeLine.to(selectedCard, {
                x: function (index, target) {
                    const targetOffsetLeft = target.offsetLeft;
                    const parentCenter = target.offsetParent.offsetWidth / 2;
                    return parentCenter - targetOffsetLeft - (target.offsetWidth / 2);
                },
                y: questionCards[0].offsetTop - selectedCard.offsetTop,
                duration
            }, 0);

            const wrapperHeight = screen.width > 500 ? 250 : 200;

            animationTimeLine.to(cardWrapper, {
                height: wrapperHeight,
                duration: .2
            }, .2);

            return animationTimeLine;
        }
    }
};
